import LectureTaskList from './lecture-task-list'

export default LectureTaskList
